export default "__VITE_ASSET__CDBr_ysL__"